

async function addPropertyToAllLineItems(newPropertyName, newPropertyValue) {
    // Fetch the cart data
  const cart = await $.getJSON('/cart.js');
   if(newPropertyValue==='AM'){
    newPropertyValue = 'Morning'
  }else if (newPropertyValue==='PM'){
 newPropertyValue = 'Standard'
  }else if(newPropertyValue==='EM'){
    newPropertyValue = 'Evening'
  }
  console.log(newPropertyName, newPropertyValue)
  for (const item of cart.items) {
    console.log(`Updating properties for item: ${item.title}`, item.properties);
  
    const updatedProperties = {
      ...item.properties,
      [newPropertyName]: newPropertyValue, // Add or update the property
    };
  
   
      const updatedCart = await $.ajax({
        type: 'POST',
        url: '/cart/change.js',
        data: {
          id: item.key,  // Using the same key as the item
          properties: updatedProperties,  // Adding the new property
          quantity : item.quantity
        },
        dataType: 'json',
        beforeSend: function () {
          // Show loading state
          $("#addcart").prop("disabled", true).text("Loading...");
          $("#loading-spinner").show();
        },
        success: function () {
          // Ensure lo ading state is updated after each request
          $("#addcart").prop("disabled", false).text("Checkout");
          $("#loading-spinner").hide();
        },
        // khairin, 8 may 1.04pm
        error: function (jqXHR, textStatus, errorThrown) {
          console.error(`Failed to update properties for item ${item.key}:`, textStatus, errorThrown, jqXHR.responseText);
          // Optionally hide loading state even on error
          $("#addcart").prop("disabled", false).text("Checkout");
          $("#loading-spinner").hide();
        }
      });
  
      console.log('Updated cart:', updatedCart);
  
      const updatedItem = updatedCart.items.find(
        (newitem) => newitem.variant_id === item.variant_id
      );
  
      console.log('HERE', updatedItem);
  
      if (updatedItem) {
        console.log('New key:', updatedItem.key);
        updateLineItemElements(updatedItem.key, item.variant_id);
      } else {
        console.error('Updated item not found in the cart.');
      }
    
  }
  
  }
  
  // Function to update line items in the DOM
  const updateLineItemElements = (updatedItemKey,variant_id) => {
      // Update <a> href for the corresponding variant_id
      // Get all <a> elements with href matching the pattern
      const links = document.querySelectorAll(`a[href*="cart/change?id=${variant_id}"]`)
      if (links.length > 0) {
        links.forEach((link) => {
        // console.log(link)
        const newLineItemKey = updatedItemKey.split(':');
        const hrefParts = link.href.split(':');
         //      console.log(hrefParts)
  
        const oldLineItemKey = hrefParts[2].split("&");
        // Update <input> data-line-key for the corresponding variant_id
        // console.log(hrefParts)
        oldLineItemKey[0]= newLineItemKey[1];
        hrefParts[2] = oldLineItemKey.join('&');
        link.href = hrefParts.join(':');
        //console.log(link)
        });
      } else {
        console.log("No matching <a> elements found.");
      }
      
  
  };